import React from "react";
import styles from './TextField.module.scss';
import PropTypes from "prop-types";

const TextField = ({
  label,
  type = 'text',
  value,
  placeholder,
  onChange,
  onBlur,
  onClick,
  disabled = false,
  error,
  min,
  max,
}) => {
  return (
    <div className={styles.textField}>
      {label && (
        <label className={styles.label}>{label}</label>
      )}
      <input
        className={`${styles.input} ${error ? styles.errorInput : ''}`}
        type={type}
        value={value || ''}
        placeholder={placeholder}
        onChange={({ target: { value } })=> {
          if (type === 'number' && max !== undefined && value !== '') {
            if (parseFloat(value) > parseFloat(max)) {
              return;
            }
          }
          onChange(value);
        }}
        onBlur={onBlur}
        onClick={onClick}
        disabled={disabled}
        min={min}
        max={max}
      />
      {error && <span className={styles.error}>{error}</span>}
    </div>
  );
};

TextField.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  type: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  placeholder: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  error: PropTypes.string,
  min: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  max: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default TextField;